module.exports = __webpack_public_path__ + "img/swissdox.26a30312.gif";